import * as yup from 'yup';

export const schema = yup.object().shape({
  date: yup.string().nullable().required('This field is required'),
});
